import React, { useMemo } from 'react';
import { Button, Table, Tag } from 'antd';
import { STATUS_COLOR, STATUS_LABEL } from '../order-management/orderStatus';
import AltcasePriceCell from '../order-management/AltcasePriceCell';
import { enrichBasketLineItems, getPublicId } from './basketOrder.helpers';

const formatCurrency = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
  }).format(n);
};

export default function BasketOrderExpandedRow({
  basketRow,
  items = [],
  canManage,
  onManageLine,
  onLineUpdated,
}) {
  const lineItems = useMemo(
    () => enrichBasketLineItems(items, basketRow),
    [items, basketRow]
  );

  const columns = useMemo(() => {
    const base = [
      { title: 'Order #', dataIndex: 'order_number', key: 'order_number', width: 220 },
      { title: 'Product', dataIndex: 'product_name', key: 'product_name', width: 180 },
      { title: 'ISIN', dataIndex: 'isin', key: 'isin', width: 140 },
      {
        title: 'Qty',
        key: 'qty',
        width: 90,
        render: (_, row) => `${row.fulfilled_quantity ?? '—'} / ${row.quantity ?? '—'}`,
      },
      {
        title: 'Partner sell',
        dataIndex: 'partner_sell_price',
        key: 'partner_sell_price',
        width: 120,
        render: (v) => formatCurrency(v),
      },
      {
        title: 'Altcase price',
        key: 'altcase_price',
        width: 200,
        render: (_, row) => (
          <AltcasePriceCell row={row} canManage={canManage} onAssigned={onLineUpdated} />
        ),
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 160,
        render: (status) => (
          <Tag color={STATUS_COLOR[status] || 'default'}>{STATUS_LABEL[status] || status}</Tag>
        ),
      },
    ];

    if (canManage) {
      base.push({
        title: '',
        key: 'actions',
        width: 120,
        render: (_, row) => (
          <Button type="link" size="small" onClick={() => onManageLine?.(row, basketRow)}>
            Manage
          </Button>
        ),
      });
    }

    return base;
  }, [basketRow, canManage, onManageLine, onLineUpdated]);

  return (
    <Table
      rowKey={(row) => getPublicId(row) || row.order_number}
      columns={columns}
      dataSource={lineItems}
      pagination={false}
      size="small"
      scroll={{ x: 'max-content' }}
      className="[&_.ant-table-thead>tr>th]:whitespace-nowrap [&_.ant-table-tbody>tr>td]:whitespace-nowrap"
    />
  );
}
